<template>
  <Checkbox-group
    :model.sync="disabledGroup"
    :type="type"
    :shape="shape"
    :style="editorStyle"
    :id="id"
  >
    <Checkbox value="香蕉"></Checkbox>
    <Checkbox value="苹果"></Checkbox>
    <Checkbox value="西瓜"></Checkbox>
  </Checkbox-group>
</template>
<script>
const component = {
  name: "hex-checkbox",
  props: {
    type: String,
    shape: String,
    st: Object,
    innerText: String,
    id: String
  },
  data() {
    return {
      editorStyle: process.env.MODE === "editor" ? this.st : {}
    };
  }
};
// 区分editor和实际打包， build之后的lib不打包
if (process.env.MODE === "editor") {
  component.define = require("./define");
}
export default component;
</script>



// WEBPACK FOOTER //
// index.vue?a30853b8